import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { ModalsContextState } from '../types';

const defaultState: ModalsContextState = {
  closeModal: noop,
  openedModals: [],
  openModal: noop,
};

export const ModalsContext = createContext<ModalsContextState>(defaultState);
export const useModalsContext = () => useContext(ModalsContext);
